import { rgba } from "../../../utils/rgba";

//TOdo: remove me
export const colors = {
  fonts: {
    primary: "Lato, sans-serif",
  },
  bg: {
    basis: "#f6f6f6",
    primary: "#ffffff",
    secondary: "#f6f6f6",
    secondary2: "#ededed",
    tertiary: "#fafafa",
    tertiary2: "#fcfcfc",
    divider: "#e7e8ef",
    login: "#1A2131",
    headerBlock: "#e8ebec",
    hover: rgba("#7748FC", 0.12),
    loader: "rgba(0, 0, 0, 0.12)",
    warning: "rgba(254, 178, 58, 0.12)",
  },
  // The candle charts used to paint themselves off `bg.login` and `txt.secondary`, both of which
  // hold the same value in either palette, so the surface stayed dark under the light theme. These
  // are the per-theme surface colours instead.
  chart: {
    background: "#ffffff",
    gridLine: "#e7e8ef",
    axisText: "#4F5867",
    crosshair: "#182524",
    tooltipBackground: "#ffffff",
    tooltipText: "#182524",
  },
  toast: {
    infoBackground: "#FFFFFF",
    warningBackground: "#FFFFFF",
    errorBackground: "#FCE7E7",
    infoMain: "rgba(38, 161, 50, 0.7)",
    warningMain: "rgba(227, 154, 45, 0.7)",
    errorMain: "rgba(229, 96, 96, 0.7)",
    textColor: "#222222",
  },
  fg: {
    primary: "#182524",
    main_primary: "#6B7373",
    secondary: "#4F5867",
    secondary2: "#6D7685",
    accent: "#7748FC",
    accentLight: "#865DFC",
    accentDark: "#633DD1",
    accent12: rgba("#7748FC", 0.12),
    accent12NoAlpha: "#ede9fc",
    accent20: rgba("#7748FC", 0.2),
    tertiary: "#A6ACB8",
    // CRM ships two artworks per nav icon; these are the fills it bakes into the
    // idle and selected variants. Same values in both themes, as in CRM.
    navIcon: "#CECECE",
    navIconActive: "#8146FF",
    green: "#56C456",
    ocean: "#27B6E4",
    purple: "#BA00D9",
    red: "#F25F64",
    orange: "#FEB23A",
    white: "#F3F6FC", // FG/FG_Batton
    black: "#182524",
  },
  border: {
    primary: rgba("#000", 0.12),
    secondary: "#5294c3",
    active: "#5142AE",
    activeRadius: rgba("#5142AE", 0.12),
    borderShadow: "rgba(0, 0, 0, 0.16)",
    boxShadow: "-4px -4px 4px 0 rgba(0, 0, 0, 0.08) inset",
    traderBoxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.08)",
    gray: "rgba(173, 167, 177, 0.3)",
  },
  progress: {
    secondary: "#D9D9D9",
    primary: "#7748FC",
  },
  grid: {
    bg: "#f7f8fa",
    rowOddBg: "#e7e8ef",
    shadow: "#cecece",
    checkboxBorder: "#ccc",
    blue: rgba("#00A3FF", 0.12),
    accent20: rgba("#00A3FF", 0.2),
    green: rgba("#56C456", 0.12),
    green20: rgba("#56C456", 0.2),
    red: rgba("#F25F64", 0.12),
    red20: rgba("#F25F64", 0.2),
    orange: rgba("#FEB23A", 0.12),
    orange20: rgba("#FEB23A", 0.2),
    headerHover: "#F3F8FF",
    fullWidthRow: "#FBFBFC",
    checkbox: "#5142AE",
    rowHover: rgba("#7748FC", 0.05),
    rowSelected: rgba("#7748FC", 0.1),
    border: rgba("#000", 0.12),
    paginationText: "#999ca3",
  },
  line: {
    primary: "#D9DEE2",
    secondary: "#242424",
  },
  btn: {
    primary: rgba("#45BD5B", 0.9),
    primary_hovered: "#45BD5B",
    primary_pressed: "#45BD5B",
    primary_disabled: rgba("#45BD5B", 0.5),
    secondary: "#FFFFFF",
    secondary_hovered: "rgba(51,51,51,0.13)",
    secondary_pressed: "#333333",
    secondary_disabled: rgba("#333333", 0.5),
    green: "#45BD5B",
    green_hovered: "#45BD5B",
    red: "#C80048",
    red_hovered: "#C80048",
    blue: "#7748FC",
    blue_hovered: "#7748FC",
    grey: "#999CA3",
    danger: "#D1474C",
  },
  icons: {
    primary: "#467EA6",
    secondary: "#000",
    tertiary: "#fff",
    bgPrimary: "#f7f7f7",
    close: "red",
    blue: "#00109C",
    bgBlue: "#EDFAFF",
  },
  txt: {
    primary: "#333333",
    blue: "#7748FC",
    secondary: "#ffffff",
    tableHead: "#5F7992",
    required: "#E34C4C",
    label: "#A6ACB8",
    value: "#182524",
    label2: "#4F5867",
    gray: "rgba(0, 0, 0, 0.5)",
    highlight: "#7748FC",
  },
  select: {
    background: "#ffffff",
    color: "#333333",
    icon: "#333333",
    hover: "#f8f8fa",
    selected: "#4f657a",
    optionHover: rgba("#7748FC", 0.12),
    optionHover1: "rgba(86, 196, 86, 0.20)",
  },
  donut: {
    shadow: "rgba(0,0,0,.5)",
  },
  modal: {
    closeIcon: "#ffffff",
  },
};
